import React, { lazy } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import Layout from 'layouts'
import ProtectedRoute from 'protectedRoutes'
import Cookies from 'js-cookie'
import UmsRoutes from 'Ums/umsRouter'
import WebSocketNotifier from './pages/WebSocketNotifier'

const routes = [
  // VB:REPLACE-START:ROUTER-CONFIG
  // {
  //   path: '/dashboard',
  //   Component: lazy(() => import('pages/dashboard/gamma')),
  //   exact: true,
  //   roles: ['employee', 'user', 'super_admin', 'hr'],
  //   modules: ['dashboard'],
  // },

  {
    path: '/dashboard/alpha',
    Component: lazy(() => import('pages/dashboard/alpha')),
    exact: true,
    roles: ['employee', 'user', 'super_admin'],
    modules: [],
  },
  {
    path: '/dashboard/beta',
    Component: lazy(() => import('pages/dashboard/beta')),
    exact: true,
    roles: ['employee', 'user', 'super_admin'],
    modules: [],
  },
  {
    path: '/dashboard/gamma',
    // path: '/ems',
    Component: lazy(() => import('pages/dashboard/gamma')),
    exact: true,
    roles: ['employee', 'user', 'super_admin', 'hr', 'trainer'],
    modules: ['dashboard'],
  },
  {
    path: '/dashboard/crypto',
    Component: lazy(() => import('pages/dashboard/crypto')),
    exact: true,
    roles: ['employee', 'user', 'super_admin'],
    modules: [],
  },

  // configuration paths
  {
    path: '/config/term-and-condition',
    Component: lazy(() => import('pages/config/termAndCondition')),
    exact: true,
    roles: ['super_admin'],
    modules: ['terms_and_condition'],
  },
  {
    path: '/config/company-policy',
    Component: lazy(() => import('pages/config/companyPolicy')),
    exact: true,
    roles: ['super_admin'],
    modules: ['company_policy'],
  },
  {
    path: '/config/leave-policy',
    Component: lazy(() => import('pages/config/leavePolicy')),
    exact: true,
    roles: ['super_admin'],
    modules: ['leave_policy'],
  },
  {
    path: '/config/doAndDont',
    Component: lazy(() => import('pages/DoAndDont')),
    exact: true,
    roles: ['super_admin'],
    modules: ['Do_And_Dont'],
  },
  {
    path: '/config/permissions',
    Component: lazy(() => import('pages/config/permissions')),
    exact: true,
    roles: ['super_admin'],
    modules: ['role_and_permissions'],
  },
  {
    path: '/config/module-permission',
    Component: lazy(() => import('pages/config/modulePermission')),
    exact: true,
    roles: ['super_admin'],
    modules: ['module_permission'],
  },
  {
    path: '/config/global-type-category',
    Component: lazy(() => import('pages/config/globaltypecategory')),
    exact: true,
    roles: ['super_admin'],
    modules: ['global_type_category'],
  },
  {
    path: '/config/global-type',
    Component: lazy(() => import('pages/config/globaltype')),
    exact: true,
    roles: ['super_admin'],
    modules: ['global_type'],
  },
  // hierarchy
  {
    path: '/config/hierarchy',
    Component: lazy(() => import('pages/config/hierarchy')),
    exact: true,
    roles: ['super_admin'],
    modules: ['hierarchy'],
  },
  // location
  {
    path: '/config/location',
    Component: lazy(() => import('pages/location')),
    exact: true,
    roles: ['super_admin'],
    modules: ['global_type'],
  },
  // staff

  {
    path: '/staff',
    Component: lazy(() => import('pages/staff')),
    exact: true,
    roles: ['super_admin', 'employee', 'user'],
    modules: ['staff'],
  },
  // employee management
  {
    path: '/emp/all-employee',
    Component: lazy(() => import('pages/emp')),
    exact: true,
    roles: ['super_admin', 'hr'],
    modules: ['employees'],
  },
  {
    path: '/emp/all-agents',
    Component: lazy(() => import('pages/agent')),
    exact: true,
    roles: ['super_admin', 'hr', 'trainer'],
    modules: ['agents'],
  },
  // onBoarding
  {
    path: '/on-board',
    Component: lazy(() => import('pages/onboard')),
    exact: true,
    roles: ['super_admin', 'hr'],
    modules: ['on_board'],
  },
  // Attendance
  {
    path: '/attendance',
    Component: lazy(() => import('pages/attendance')),
    exact: true,
    roles: ['super_admin', 'employee', 'user'],
    modules: ['attendance'],
  },
  // down time
  {
    path: '/down-time',
    Component: lazy(() => import('pages/downTime')),
    exact: true,
    roles: ['super_admin', 'employee', 'user'],
    modules: ['down_time'],
  },
  // roster upload
  {
    path: '/roster',
    Component: lazy(() => import('pages/roster')),
    exact: true,
    roles: ['super_admin'],
    modules: ['roster'],
  },
  // exceptions
  {
    path: '/exception',
    Component: lazy(() => import('pages/exception')),
    exact: true,
    roles: ['super_admin', 'employee', 'user'],
    modules: ['exception'],
  },
  // Leave management
  {
    path: '/calendar',
    Component: lazy(() => import('pages/leave/employeeLeave')),
    exact: true,
    roles: ['hr', 'super_admin', 'employee', 'user'],
    modules: ['calender'],
  },
  // Leave approval
  {
    path: '/leave-request',
    Component: lazy(() => import('pages/leave/leaveRequest')),
    exact: true,
    roles: ['hr', 'super_admin', 'employee', 'user'],
    modules: ['leave_request', 'leave_approval'],
  },
  // RYG Status
  {
    path: '/RAGstatus',
    Component: lazy(() => import('pages/RYGStatus')),
    exact: true,
    roles: ['hr', 'super_admin', 'employee', 'user'],
    modules: ['ryg_status'],
  },
  // Happy to Help
  {
    path: '/happy-to-help',
    Component: lazy(() => import('pages/happyToHelp')),
    exact: true,
    modules: ['happy_to_help'],
    roles: ['super_admin', 'employee', 'user'],
  },
  // Resignation
  {
    path: '/resignation',
    Component: lazy(() => import('pages/resignation')),
    exact: true,
    modules: ['resignation'],
    roles: ['super_admin', 'employee', 'user'],
  },

  // Edit Profile
  {
    path: '/profile',
    Component: lazy(() => import('pages/editProfile')),
    exact: true,
    modules: ['profile'],
    roles: ['super_admin', 'employee', 'user'],
  },
  // Salary slip for user
  {
    path: '/salary-slip',
    Component: lazy(() => import('pages/salarySlip/index')),
    exact: true,
    modules: ['salary_slip'],
    roles: ['super_admin', 'employee', 'user'],
  },
  // Documents
  {
    path: '/documents',
    Component: lazy(() => import('pages/documents')),
    exact: true,
    modules: ['documents'],
    roles: ['super_admin'],
  },

  {
    path: '/emp/payroll',
    Component: lazy(() => import('pages/payroll')),
    exact: true,
    roles: ['super_admin', 'hr', ''],
    modules: ['payroll'],
  },
  {
    path: '/payroll/:userId',
    Component: lazy(() => import('pages/payroll/viewPayroll/index')),
    exact: true,
    modules: ['payroll'],
    roles: ['employee', 'user', 'super_admin'],
  },
  // Auth
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
    modules: ['logIn'],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/auth/forgot-password')),
    exact: true,
    modules: [],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/auth/reset-password',
    Component: lazy(() => import('pages/auth/reset-password')),
    exact: true,
    modules: [],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
    modules: [],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
    modules: ['lockscreen'],
    roles: ['super_admin', 'employee', 'user'],
  },
  {
    path: '/under-construction',
    Component: lazy(() => import('pages/underConstruction')),
    exact: true,
    modules: ['under_construction'],
    roles: ['super_admin'],
  },
  {
    path: '/teams',
    Component: lazy(() => import('pages/teams')),
    exact: true,
    modules: [],
    roles: ['super_admin'],
  },
  {
    path: '/acknowledgement',
    Component: lazy(() => import('pages/acknowledgement')),
    exact: true,
    modules: ['acknowledgement'],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/acknowledgement/:docId',
    Component: lazy(() => import('pages/acknowledgement/ViewDoc')),
    exact: true,
    modules: ['acknowledgement'],
    roles: ['employee', 'user', 'super_admin'],
    permission: 'view-details',
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
    modules: ['404'],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
    modules: ['500'],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/auth/candidate-form',
    Component: lazy(() => import('pages/onboard/addCandidateForm/addForm')),
    exact: true,
    modules: [],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/attendance-report',
    Component: lazy(() => import('pages/report/attendnaceReport')),
    exact: true,
    modules: ['attendance_report'],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/attendance-report/:userId',
    Component: lazy(() => import('pages/report/attendnaceReport/report')),
    exact: true,
    modules: ['attendance_report'],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/leave-report',
    Component: lazy(() => import('pages/report/leaveReport')),
    exact: true,
    modules: ['leave_report'],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/leave-report/:userId',
    Component: lazy(() => import('pages/report/leaveReport/report')),
    exact: true,
    modules: ['leave_report'],
    roles: ['employee', 'user', 'super_admin'],
  },
  {
    path: '/expenses',
    Component: lazy(() => import('pages/expenses/index')),
    exact: true,
    modules: ['expenses'],
    roles: ['hr', 'super_admin'],
  },
  {
    path: '/reimbursement',
    Component: lazy(() => import('pages/reimbursement/index')),
    exact: true,
    modules: ['reimbursement'],
    roles: ['employee', 'hr', 'super_admin'],
  },

  {
    path: '/ems',
    Component: lazy(() => import('pages/dashboard/gamma')),
    exact: true,
    roles: ['employee', 'user', 'super_admin', 'hr'],
    modules: ['dashboard'],
  },

  /** ****
   * All projects detailed routes
   * ***** */

  {
    path: '/projects-module-master',
    Component: lazy(() => import('./@vb/components/moduleCards/index')),
    exact: true,
    modules: ['projects'],
    roles: ['employee', 'user', 'super_admin'],
  },
  // {
  //   path: '/ums',
  //   Component: lazy(() => import('./Ums/pages/dashboard/ums/index')),
  //   exact: true,
  //   modules: ['projects'],
  //   roles: ['employee', 'user', 'super_admin'],
  // },

  // {
  //   path: '/ems',
  //   // Component: lazy(() => import('./Ums/pages/dashboard/ums/index')),
  //   // Component: lazy(() => import('./Wms/pages/dashboard/wms/index')),
  //   // Component: lazy(() => import('./Qms/pages/dashboard/qms/index')),
  //   exact: true,
  //   modules: ['projects'],
  //   roles: ['employee', 'user', 'super_admin'],
  // },

  {
    path: '/wms',
    Component: lazy(() => import('./Wms/pages/dashboard/wms')),
    exact: true,
    modules: ['projects'],
    roles: ['employee', 'user', 'super_admin'],
  },

  {
    path: '/qms',
    Component: lazy(() => import('./Qms/pages/dashboard/qms')),
    exact: true,
    modules: ['projects'],
    roles: ['employee', 'user', 'super_admin'],
  },
]

const mapStateToProps = ({ settings }) => ({
  routerAnimation: settings.routerAnimation,
})

// const Router = ({ history, routerAnimation }) => {
//   return (
//     <ConnectedRouter history={history}>
//       <Layout>
//         <WebSocketNotifier />
//         <Route
//           render={(state) => {
//             const { location } = state
//             return (
//               <SwitchTransition>
//                 <CSSTransition
//                   key={location.pathname}
//                   appear
//                   classNames={routerAnimation}
//                   timeout={routerAnimation === 'none' ? 0 : 300}
//                 >
//                   <Switch location={location}>
//                     {/* VB:REPLACE-NEXT-LINE:ROUTER-REDIRECT */}

//                     <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
//                     {routes.map(({ path, Component, exact, roles, modules, permission }) => (
//                       <ProtectedRoute
//                         key={path}
//                         path={path}
//                         exact={exact}
//                         Component={Component}
//                         roles={roles}
//                         modules={modules}
//                         routerAnimation={routerAnimation}
//                         permission={permission}
//                       />
//                     ))}
//                     <Redirect to="/auth/404" />
//                   </Switch>
//                 </CSSTransition>
//               </SwitchTransition>
//             )
//           }}
//         />
//       </Layout>
//     </ConnectedRouter>
//   )
// }

const Router = ({ history, routerAnimation }) => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        {/* Login page outside layout */}
        <Route
          path="/auth/login"
          render={(props) => {
            const isAuthenticated = !!Cookies.get('accessToken')
            if (isAuthenticated) {
              return <Redirect to={module?.path} /> // redirect to module dashboard
            }
            return (
              <ProtectedRoute
                {...props}
                path="/auth/login"
                exact
                Component={lazy(() => import('pages/auth/login'))}
                roles={['employee', 'user', 'super_admin']}
                modules={['logIn']}
                routerAnimation={routerAnimation}
              />
            )
          }}
        />

        {/* Project module cards outside layout */}
        <Route
          path="/projects-module-master"
          render={(props) => {
            const isAuthenticated = !!Cookies.get('accessToken')
            if (isAuthenticated) {
              return <Redirect to={module?.path} />
            }
            return (
              <ProtectedRoute
                {...props}
                path="/projects-module-master"
                exact
                Component={routes.find((r) => r.path === '/projects-module-master').Component}
                roles={['employee', 'user', 'super_admin', 'hr']}
                modules={['projects']}
                routerAnimation={routerAnimation}
              />
            )
          }}
        />

        {/* 🚀 Project-level apps (Protected, NO Layout) */}
        <ProtectedRoute
          path="/ums"
          Component={lazy(() => import('./Ums/pages/dashboard/ums/index'))}
          roles={['employee', 'user', 'super_admin']}
          modules={['ums']}
          routerAnimation={routerAnimation}
        />
        <ProtectedRoute
          path="/wms"
          exact
          Component={lazy(() => import('./Wms/pages/dashboard/wms'))}
          roles={['employee', 'user', 'super_admin']}
          modules={['wms']}
          routerAnimation={routerAnimation}
        />
        <ProtectedRoute
          path="/qms"
          exact
          Component={lazy(() => import('./Qms/pages/dashboard/qms'))}
          roles={['employee', 'user', 'super_admin']}
          modules={['qms']}
          routerAnimation={routerAnimation}
        />

        {/* All other routes INSIDE global Layout */}
        <Route
          render={(state) => {
            const { location } = state
            return (
              <Layout>
                <WebSocketNotifier />
                <SwitchTransition>
                  <CSSTransition
                    key={location.pathname}
                    appear
                    classNames={routerAnimation}
                    timeout={routerAnimation === 'none' ? 0 : 300}
                  >
                    <Switch location={location}>
                      {/* Default route goes to login */}
                      <Route exact path="/" render={() => <Redirect to="/auth/login" />} />

                      {[...routes, ...UmsRoutes]
                        .filter(
                          (r) =>
                            r.path !== '/projects-module-master' &&
                            r.path !== '/auth/login' &&
                            !['/ums', '/wms', '/qms'].includes(r.path),
                        )
                        .map(({ path, Component, exact, roles, modules, permission }) => (
                          <ProtectedRoute
                            key={path}
                            path={path}
                            exact={exact}
                            Component={Component}
                            roles={roles}
                            modules={modules}
                            routerAnimation={routerAnimation}
                            permission={permission}
                          />
                        ))}
                      <Redirect to="/auth/404" />
                    </Switch>
                  </CSSTransition>
                </SwitchTransition>
              </Layout>
            )
          }}
        />
      </Switch>
    </ConnectedRouter>
  )
}

// const Router = ({ history, routerAnimation }) => {
//   return (
//     <ConnectedRouter history={history}>
//       <Switch>
//         {/* Login page outside layout */}
//         <Route
//           exact
//           path="/auth/login"
//           render={props => {
//             const isAuthenticated = !!Cookies.get('accessToken');
//             if (isAuthenticated) {
//               return <Redirect to={module?.path} />;
//             }
//              return (
//                <ProtectedRoute
//                  {...props}
//                  path="/auth/login"
//                  exact
//                  Component={lazy(() => import('pages/auth/login'))}
//                  roles={['employee', 'user', 'super_admin']}
//                  modules={['logIn']}
//                  routerAnimation={routerAnimation}
//                />
//   )}}
//         />
//         {/* Project module cards outside layout */}
//         <Route
//           exact
//           path="/projects-module-master"
//           render={props => {
//             const isAuthenticated = !!Cookies.get('accessToken');
//             if (isAuthenticated) {
//               return <Redirect to={module?.path} />;
//             }
//              // Not authenticated: show the project cards
//               return (
//                 <ProtectedRoute
//                   {...props}
//                   path="/projects-module-master"
//                   exact
//                   Component={routes.find(r => r.path === '/projects-module-master').Component}
//                   roles={['employee', 'user', 'super_admin','hr']}
//                   modules={['projects']}
//                   routerAnimation={routerAnimation}
//                 />
//             );
//           }}
//         />

//         {/* All other routes inside layout */}
//         <Route
//           render={state => {
//             const { location } = state
//             return (
//               <Layout>
//                 <WebSocketNotifier />
//                 <SwitchTransition>
//                   <CSSTransition
//                     key={location.pathname}
//                     appear
//                     classNames={routerAnimation}
//                     timeout={routerAnimation === 'none' ? 0 : 300}
//                   >
//                     <Switch location={location}>
//                       {/* Default route goes to login */}
//                       <Route exact path="/" render={() => <Redirect to="/auth/login" />} />
//                       {routes
//                         .filter(r => r.path !== '/projects-module-master' && r.path !== '/auth/login')
//                         .map(({ path, Component, exact, roles, modules, permission }) => (
//                           <ProtectedRoute
//                             key={path}
//                             path={path}
//                             exact={exact}
//                             Component={Component}
//                             roles={roles}
//                             modules={modules}
//                             routerAnimation={routerAnimation}
//                             permission={permission}
//                           />
//                         ))}
//                       <Redirect to="/auth/404" />
//                     </Switch>
//                   </CSSTransition>
//                 </SwitchTransition>
//               </Layout>
//             )
//           }}
//         />
//       </Switch>
//     </ConnectedRouter>
//   )
// }

export default connect(mapStateToProps)(Router)
